<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-800">
        <authentication-card-logo dusk="login-screen-logo"/>

        <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-gray-800 shadow-md overflow-hidden sm:rounded-lg border border-gray-700">
            <form @submit.prevent="submitForm">
                <h1 class="text-xl text-gray-200 flex justify-center"><template v-if="username">{{username}} </template>{{ $t('login') }}</h1>
                <template v-if="username">
                    <input id="email" class="form-input rounded-md shadow-sm block mt-1 w-full" type="hidden" name="username" v-model="username" required autofocus>
                </template>
                <template v-else-if="admin && user">
                    <div class="text-white">
                        {{ $t('You are going to impersonate as') }} <strong>{{ user }}</strong>
                    </div>
                    <div class="text-white">
                        {{ $t('Please type your backoffice password') }}
                    </div>
                </template>
                <template v-else>
                    <div>
                        <label for="email" class="block font-medium text-sm text-gray-200">{{ $t('Username') }}</label>
                        <input id="email" class="form-input rounded-md shadow-sm block mt-1 w-full" type="text" name="username" v-model="form.username" required autofocus>
                    </div>
                </template>

                <div class="mt-4">
                    <label for="password" class="block font-medium text-sm text-gray-200">{{ $t('Password') }}</label>
                    <input id="password" class="form-input rounded-md shadow-sm block mt-1 w-full" type="password" name="password" v-model="form.password" required autocomplete="current-password">
                </div>

                <validation-errors :errors="errors" />

                <div class="flex items-center justify-center mt-4">
                    <button type="submit" class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 w-full my-6 justify-center text-center bg-purple-700 hover:bg-purple-600 focus:bg-purple-500" dusk="login-button">
                        {{ $t('Login') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import ValidationErrors from "../../Shared/Components/ValidationErrors.vue";
import AuthenticationCardLogo from "../../Shared/Components/AuthenticationCardLogo.vue";

export default {
    name: 'CasinoLogin',
    components: {AuthenticationCardLogo, ValidationErrors},
    props: {
        imageUrl: String,
        admin: {
            type: String,
            default: null
        },
        user: {
            type: String,
            default: null
        },
        username: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            form: {
                username: '',
                password: '',
            },
            errors: [],
        }
    },
    methods: {
        updateHiddenUsername() {
            if (this.username) {
                this.form.username = this.username;
            } else if (this.admin && this.user) {
                this.form.username = `${this.admin}:${this.user}`;
            }
        },
        async submitForm() {
            await axios.get('/sanctum/csrf-cookie');
            this.updateHiddenUsername();
            try {
                await axios.post(this.route('login'), this.form)

                window.location.replace(this.route('casino.home').url());
            } catch(error) {
                if (error.response && error.response.status === 422) {
                    this.errors = Object.values(error.response.data).flat();
                } else if (error.response && error.response.status === 419) {
                    // CSRF token mismatch.
                    this.errors = ['Session expired. Please refresh the page and try again.'];
                }
            }
        },
    },
}
</script>
